import { render, staticRenderFns } from "./AddBankPayment.vue?vue&type=template&id=6ee95ebe"
import script from "./AddBankPayment.vue?vue&type=script&lang=js"
export * from "./AddBankPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports